<template>
    <div class="flex flex-row px-4 py-5">
        <div class="flex flex-col shadow-lg rounded-lg items-center bg-white w-52">
            <div class="flex justify-center items-center">
                <img :src="url"
                  alt="foto profilo"
                  class="rounded-t-lg">
            </div>
            <div class="my-5 text-left w-full">
              <div class="flex flex-col justify-between items-center divide-y
                divide-grey-academy-200 mx-4">
                <h1 class="text-md self-center mx-3 pb-1"> {{ userName }}</h1>
                <stars-rate :starsAvg="starsAvg" class="justify-center pt-2"
                  starsClass="w-5 pl-1"  />
              </div>

                <h1 class="text-lg md:self-start mx-3 pt-1">
                  {{ userType }}</h1>

            </div>
        </div>
    </div>
</template>

<script>
import StreamFunctionsMixin from '@/mixins/StreamFunctionsMixin';
import StarsRate from './graphics/StarsRate.vue';

export default {
  components: { StarsRate },
  props: {
    userName: String,
    userType: String,
    urlPhoto: String,
    starsAvg: Number,
  },

  computed: {
    url() {
      return this.urlPhoto ? this.urlPhoto : 'https://baroon.fra1.digitaloceanspaces.com/dev/academy/users/UserIcon.png';
    },
  },

  mixins: [StreamFunctionsMixin],

};
</script>
